export default __webpack_public_path__ + "images/parent-signup/assignment_icon-5567eb7cad7c1a5c77aa4c47285b708c.svg";